function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66",
  fill: "#00a3e0"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 31",
  d: "M32.537 26.03H3.9a3.906 3.906 0 01-3.9-3.9V3.9A3.906 3.906 0 013.9 0h28.637a3.906 3.906 0 013.9 3.9v18.225a3.906 3.906 0 01-3.9 3.905zM3.9 2.6a1.3 1.3 0 00-1.3 1.3v18.225a1.3 1.3 0 001.3 1.3h28.637a1.3 1.3 0 001.3-1.3V3.9a1.3 1.3 0 00-1.3-1.3z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 32",
  d: "M19.08 18.221h-1.718a1.309 1.309 0 01-.646-.172L3.558 10.531l1.3-2.259 12.841 7.346h1.042l12.856-7.346 1.3 2.259-13.172 7.518a1.309 1.309 0 01-.645.172z"
}));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.442 26.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cbc71408.svg";
export { ForwardRef as ReactComponent };